import { render, staticRenderFns } from "./UniversalCode.vue?vue&type=template&id=29a99cd4&scoped=true"
import script from "./UniversalCode.vue?vue&type=script&lang=js"
export * from "./UniversalCode.vue?vue&type=script&lang=js"
import style0 from "./UniversalCode.vue?vue&type=style&index=0&id=29a99cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a99cd4",
  null
  
)

export default component.exports